export enum DateTimePickerType {
    DateTimePicker = 'DateTimePicker',
    DatePicker = 'DatePicker',
    TimePicker = 'TimePicker',
}
